export default __webpack_public_path__ + "static/media/cat15.ac1e78be.gif";